import Vue from 'vue';

export default {
    postDownload: function (url, data, callback, callbackError = null) {
        this.createAxiosBlob(url, 'POST', data, callback, callbackError);
    },

    getDownload: function (url, callback, callbackError = null) {
        this.createAxiosBlob(url, 'GET', null, callback, callbackError);
    },

    createAxiosBlob: function (url, method, data, callback, callbackError = null) {
        const self = this;

        let options = {
            url: url,
            method: method,
            responseType: 'blob', // Sempre manter como 'blob'
        };

        if (data !== undefined && data !== null) {
            options['data'] = data;
        }

        Vue.axios(options)
            .then((response) => {
                // Força o download do arquivo
                self.forcarDownloadNoBrowser(response);

                // Executa o callback de sucesso, se existir
                if (typeof callback === 'function') {
                    callback(response);
                }
            })
            .catch((error) => {
                // Executa o callback de erro, se existir
                if (callbackError && typeof callbackError === 'function') {
                    callbackError(error);
                }
            });
    },

    forcarDownloadNoBrowser: function (response) {
        if (!response || !response.data) {
            throw new Error('A resposta não contém dados válidos.');
        }

        let filename = 'arquivo';
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
            const matches = contentDisposition.match(/filename="?(?<file>[^"]+)"?/);
            if (matches && matches.groups) {
                filename = matches.groups.file;
            }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
    },
};
